<div class="dash-menu" [class.dash-menu--collapsed]="isCollapse">
	<div
		class="dash-menu__nav"
		[class.dash-menu__nav--more-above]="navMoreAbove"
		[class.dash-menu__nav--more-below]="navMoreBelow"
	>
		<ul
			class="menu main"
			data-test="menu"
			id="parentMenu"
			#navMenu
			[class.menu--collapsed]="isCollapse"
			(scroll)="onNavScroll()"
		>
			@if (showGetStartedTabFlag) {
				<li
					class="menu__item"
					[ngClass]="
						activeGetStartedLink ? 'menu__item--active' : ' '
					"
					data-test="dash-menu-get-started"
					[matTooltip]="'Get Started'"
					matTooltipPosition="left"
					matTooltipClass="indicator__tooltip"
					[matTooltipDisabled]="!isCollapse"
				>
					<a
						class="menu__item-link"
						mat-button
						id="get-started"
						color="link"
						[routerLink]="['get-started']"
						[ngClass]="{ 'link-collapse': isCollapse }"
					>
						<span class="icon icon-check-circle"></span>
						@if (!isCollapse) {
							<span class="label" data-test="dash-menu-label">
								Get Started
							</span>
						}
					</a>
				</li>
			}
			<li
				class="menu__item"
				[ngClass]="
					activePortfolioRouterLink ? 'menu__item--active' : ' '
				"
				data-test="dash-menu-portfolio"
				[matTooltip]="'Portfolio'"
				matTooltipPosition="left"
				matTooltipClass="indicator__tooltip"
				[matTooltipDisabled]="!isCollapse"
			>
				<a
					class="menu__item-link"
					mat-button
					id="portfolio"
					color="link"
					[routerLink]="['clients']"
					[ngClass]="{ 'link-collapse': isCollapse }"
				>
					<span class="icon icon-pyramid"></span>
					@if (!isCollapse) {
						<span class="label" data-test="dash-menu-label">
							Portfolio
						</span>
					}
				</a>
			</li>
			<li
				class="menu__item"
				[ngClass]="
					activeDataSourcesRouterLink ? 'menu__item--active' : ' '
				"
				data-test="dash-menu-data-sources"
				[matTooltip]="'Data Sources'"
				matTooltipPosition="left"
				matTooltipClass="indicator__tooltip"
				[matTooltipDisabled]="!isCollapse"
			>
				<a
					class="menu__item-link"
					mat-button
					color="link"
					[routerLink]="
						selectedClientId
							? ['clients', selectedClientId, 'data-sources']
							: ['data-sources']
					"
					[ngClass]="{ 'link-collapse': isCollapse }"
				>
					<span class="icon icon-share-2"></span>
					@if (!isCollapse) {
						<span class="label" data-test="dash-menu-label">
							Data Sources
						</span>
					}
				</a>
			</li>
			<li
				class="menu__item"
				[ngClass]="
					activeDataChatRouterLink ? 'menu__item--active' : ' '
				"
				data-test="dash-menu-data-chat"
				[matTooltip]="isCollapse ? 'Data Chat (New)' : 'Data Chat'"
				matTooltipPosition="left"
				matTooltipClass="indicator__tooltip"
				[matTooltipDisabled]="!isCollapse"
			>
				<a
					class="menu__item-link"
					mat-button
					color="link"
					[routerLink]="
						selectedClientId
							? ['clients', selectedClientId, 'chats']
							: ['chats']
					"
					[ngClass]="{ 'link-collapse': isCollapse }"
				>
					<span class="menu-icon-with-badge">
						<span class="icon icon-message-circle"></span>
						@if (isCollapse) {
							<span
								class="menu-feature-badge menu-feature-badge--collapsed"
								aria-hidden="true"
								>✦</span
							>
						}
					</span>
					@if (!isCollapse) {
						<span
							id="data-chat-menu-new"
							class="label data-chat-menu-label"
							data-test="dash-menu-label"
							[matBadge]="'NEW'"
							matBadgeOverlap="false"
							matBadgeSize="small"
							>Data Chat</span
						>
					}
				</a>
			</li>
			<li
				class="menu__item"
				[ngClass]="activeReportsRouterLink ? 'menu__item--active' : ' '"
				data-test="dash-menu-reports"
				[matTooltip]="isCollapse ? 'Reports (New)' : 'Reports'"
				matTooltipPosition="left"
				matTooltipClass="indicator__tooltip"
				[matTooltipDisabled]="!isCollapse"
			>
				<a
					class="menu__item-link"
					mat-button
					color="link"
					[routerLink]="
						selectedClientId
							? ['clients', selectedClientId, 'reports']
							: ['reports']
					"
					[ngClass]="{ 'link-collapse': isCollapse }"
				>
					<span class="menu-icon-with-badge">
						<span class="icon icon-file-text"></span>
						@if (isCollapse) {
							<span
								class="menu-feature-badge menu-feature-badge--collapsed"
								aria-hidden="true"
								>✦</span
							>
						}
					</span>
					@if (!isCollapse) {
						<span
							id="reports-menu-new"
							class="label reports-menu-label"
							data-test="dash-menu-label"
							[matBadge]="'NEW'"
							matBadgeOverlap="false"
							matBadgeSize="small"
							>Reports</span
						>
					}
				</a>
			</li>
			@if (showAiVisibilityMenu) {
				<li
					class="menu__item"
					[ngClass]="
						activeAiVisibilityLink ? 'menu__item--active' : ' '
					"
					data-test="dash-menu-ai-visibility"
					[matTooltip]="
						isCollapse ? 'AI Visibility (Beta)' : 'AI Visibility'
					"
					matTooltipPosition="left"
					matTooltipClass="indicator__tooltip"
					[matTooltipDisabled]="!isCollapse"
				>
					<a
						class="menu__item-link"
						mat-button
						color="link"
						[routerLink]="
							selectedClientId
								? ['clients', selectedClientId, 'ai-visibility']
								: ['ai-visibility']
						"
						[ngClass]="{ 'link-collapse': isCollapse }"
					>
						<span class="menu-icon-with-badge">
							<span class="icon icon-eye"></span>
							@if (isCollapse) {
								<span
									class="menu-feature-badge menu-feature-badge--collapsed menu-feature-badge--beta"
									aria-hidden="true"
								>
									<svg
										class="menu-feature-badge__beta-icon"
										viewBox="0 -960 960 960"
										aria-hidden="true"
									>
										<!-- Material Symbol: experiment -->
										<path
											fill="currentColor"
											d="M200-120q-51 0-72.5-45.5T138-250l222-270v-240h-40q-17 0-28.5-11.5T280-800q0-17 11.5-28.5T320-840h320q17 0 28.5 11.5T680-800q0 17-11.5 28.5T640-760h-40v240l222 270q32 39 10.5 84.5T760-120H200Zm80-120h400L544-400H416L280-240Zm-80 40h560L520-492v-268h-80v268L200-200Zm280-280Z"
										/>
									</svg>
								</span>
							}
						</span>
						@if (!isCollapse) {
							<span
								id="ai-visibility-menu-beta"
								class="label ai-visibility-menu-label"
								data-test="dash-menu-label"
								[matBadge]="'BETA'"
								matBadgeOverlap="false"
								matBadgeSize="small"
								>AI Visibility</span
							>
						}
					</a>
				</li>
			}
			<li
				class="menu__item insight-link"
				[ngClass]="
					activeInsightsRouterLink ? 'menu__item--active' : ' '
				"
				data-test="dash-menu-insights"
				[matTooltip]="'Insights'"
				matTooltipPosition="left"
				matTooltipClass="indicator__tooltip"
				[matTooltipDisabled]="!isCollapse"
			>
				<a
					class="menu__item-link"
					mat-button
					color="link"
					[routerLink]="
						selectedClientId
							? ['clients', selectedClientId, 'insights']
							: ['insights']
					"
					[ngClass]="{ 'link-collapse': isCollapse }"
				>
					<span class="icon icon-zap"></span>
					@if (!isCollapse) {
						<span class="label" data-test="dash-menu-label"
							>Insights
							@if (
								(insightsUnresolvedCount$ | async)?.count < 100
							) {
								<span
									class="insight-badge"
									[matBadge]="
										
											(insightsUnresolvedCount$ | async)
												?.count
										
									"
									[matBadgeHidden]="
										
											(insightsUnresolvedCount$ | async)
												?.count
										 <= 0
									"
									matBadgeOverlap="false"
									matBadgeSize="small"
								></span>
							}
							@if (
								(insightsUnresolvedCount$ | async)?.count > 99
							) {
								<span
									class="insight-badge plus"
									matBadge="99+"
									[matBadgeHidden]="
										
											(insightsUnresolvedCount$ | async)
												?.count
										 <= 0
									"
									matBadgeOverlap="false"
									matBadgeSize="small"
								></span>
							}
						</span>
					}
				</a>
			</li>
			<li
				class="menu__item"
				[ngClass]="activeLocalListingsLink ? 'menu__item--active' : ' '"
				data-test="dash-menu-local-listings"
				[matTooltip]="'Local Listings'"
				matTooltipPosition="left"
				matTooltipClass="indicator__tooltip"
				[matTooltipDisabled]="!isCollapse"
			>
				<a
					class="menu__item-link"
					mat-button
					color="link"
					[routerLink]="
						selectedClientId
							? ['clients', selectedClientId, 'local']
							: ['local']
					"
					[ngClass]="{ 'link-collapse': isCollapse }"
				>
					<span class="icon icon-map-pin"></span>
					@if (!isCollapse) {
						<span class="label" data-test="dash-menu-label">
							Local Listings
						</span>
					}
				</a>
			</li>
			<li
				class="menu__item"
				[ngClass]="activeReviewsLink ? 'menu__item--active' : ' '"
				data-test="dash-menu-reviews"
				[matTooltip]="'Reviews'"
				matTooltipPosition="left"
				matTooltipClass="indicator__tooltip"
				[matTooltipDisabled]="!isCollapse"
			>
				<a
					class="menu__item-link"
					mat-button
					color="link"
					[routerLink]="
						selectedClientId
							? [
									'clients',
									selectedClientId,
									'reviews',
									'profiles',
								]
							: ['reviews', 'profiles']
					"
					[ngClass]="{ 'link-collapse': isCollapse }"
				>
					<span class="icon icon-star"></span>
					@if (!isCollapse) {
						<span class="label" data-test="dash-menu-label"
							>Reviews</span
						>
					}
				</a>
			</li>
			<li
				class="menu__item"
				[ngClass]="activeSocialPostsLinks ? 'menu__item--active' : ' '"
				data-test="dash-menu-social-posts"
				[matTooltip]="'Social Posts'"
				matTooltipPosition="left"
				matTooltipClass="indicator__tooltip"
				[matTooltipDisabled]="!isCollapse"
			>
				<a
					class="menu__item-link"
					mat-button
					color="link"
					[routerLink]="
						selectedClientId
							? ['clients', selectedClientId, 'posts']
							: ['posts']
					"
					[ngClass]="{ 'link-collapse': isCollapse }"
				>
					<span class="icon icon-hash"></span>
					@if (!isCollapse) {
						<span class="label" data-test="dash-menu-label">
							Social Posts
						</span>
					}
				</a>
			</li>
			<li
				class="menu__item"
				[ngClass]="
					activeKPIManagementRouterLink ? 'menu__item--active' : ' '
				"
				data-test="dash-menu-kpi-management"
				[matTooltip]="'KPI Forecasting'"
				matTooltipPosition="left"
				matTooltipClass="indicator__tooltip"
				[matTooltipDisabled]="!isCollapse"
			>
				<a
					class="menu__item-link"
					mat-button
					color="link"
					[routerLink]="
						selectedClientId
							? ['clients', selectedClientId, 'kpis']
							: ['kpis']
					"
					[ngClass]="{ 'link-collapse': isCollapse }"
				>
					<span class="icon icon-activity"></span>
					@if (!isCollapse) {
						<span class="label" data-test="dash-menu-label">
							KPI Forecasting
						</span>
					}
				</a>
			</li>
			<li
				class="menu__item"
				[ngClass]="
					activeBudgetTrackerRouterLink ? 'menu__item--active' : ' '
				"
				data-test="dash-menu-budget-tracker"
				[matTooltip]="'Budget Tracker'"
				matTooltipPosition="left"
				matTooltipClass="indicator__tooltip"
				[matTooltipDisabled]="!isCollapse"
			>
				<a
					class="menu__item-link"
					mat-button
					color="link"
					[routerLink]="
						selectedClientId
							? ['clients', selectedClientId, 'budgets']
							: ['budgets']
					"
					[ngClass]="{ 'link-collapse': isCollapse }"
				>
					<span class="icon icon-dollar-sign"></span>
					@if (!isCollapse) {
						<span class="label" data-test="dash-menu-label">
							Budget Tracker
						</span>
					}
				</a>
			</li>
			<li
				class="menu__item"
				[ngClass]="
					activeAnomalyDetectionRouterLink
						? 'menu__item--active'
						: ' '
				"
				data-test="dash-menu-anomaly-detection"
				[matTooltip]="'Anomaly Detection'"
				matTooltipPosition="left"
				matTooltipClass="indicator__tooltip"
				[matTooltipDisabled]="!isCollapse"
			>
				<a
					class="menu__item-link"
					mat-button
					color="link"
					[routerLink]="
						selectedClientId
							? ['clients', selectedClientId, 'anomalies']
							: ['anomalies']
					"
					[ngClass]="{ 'link-collapse': isCollapse }"
				>
					<span class="icon icon-alert-triangle"></span>
					@if (!isCollapse) {
						<span class="label" data-test="dash-menu-label">
							Anomaly Detection
						</span>
					}
				</a>
			</li>
			<li
				class="menu__item"
				[ngClass]="
					activeAutomationRouterLink ? 'menu__item--active' : ' '
				"
				data-test="dash-menu-automation"
				[matTooltip]="'Automation'"
				matTooltipPosition="left"
				matTooltipClass="indicator__tooltip"
				[matTooltipDisabled]="!isCollapse"
			>
				<a
					class="menu__item-link"
					mat-button
					color="link"
					[routerLink]="
						selectedClientId
							? ['clients', selectedClientId, 'automations']
							: ['automations']
					"
					[ngClass]="{ 'link-collapse': isCollapse }"
				>
					<span class="icon icon-rotate-cw"></span>
					@if (!isCollapse) {
						<span class="label" data-test="dash-menu-label">
							Automation
						</span>
					}
				</a>
			</li>

			<li
				class="menu__item"
				[ngClass]="
					activeClientSettingsRouterLink ? 'menu__item--active' : ' '
				"
				data-test="dash-menu-settings"
				[matTooltip]="'Settings'"
				matTooltipPosition="left"
				matTooltipClass="indicator__tooltip"
				[matTooltipDisabled]="!isCollapse"
			>
				<a
					class="menu__item-link"
					mat-button
					color="link"
					[routerLink]="
						selectedClientId
							? [
									'clients',
									selectedClientId,
									'settings',
									'profile',
								]
							: ['settings', 'account']
					"
					[ngClass]="{ 'link-collapse': isCollapse }"
				>
					<span class="icon icon-settings"></span>
					@if (!isCollapse) {
						<span class="label" data-test="dash-menu-label">
							Settings
						</span>
					}
				</a>
			</li>

			<li class="divider"></li>

			<li
				class="menu__item"
				[ngClass]="
					activeDataWareHouseRouterLink ? 'menu__item--active' : ''
				"
				[routerLink]="['pipelines']"
				data-test="dash-menu-datawarehouse"
				[matTooltip]="'Data Warehouse'"
				matTooltipPosition="left"
				matTooltipClass="indicator__tooltip"
				[matTooltipDisabled]="!isCollapse"
			>
				<a
					class="menu__item-link"
					mat-button
					color="link"
					[ngClass]="{ 'link-collapse': isCollapse }"
				>
					<span class="icon icon-database"></span>
					@if (!isCollapse) {
						<span class="label" data-test="dash-menu-label">
							Data Warehouse
						</span>
					}
				</a>
			</li>
		</ul>
	</div>
	<div
		class="menu-footer"
		id="jep-menu-footer"
		[class.menu-footer--collapsed]="isCollapse"
	>
		<div
			class="menu-footer__admin menu__item"
			[ngClass]="activeAdminRouterLink ? 'menu__item--active' : ' '"
			data-test="dash-menu-item"
			[matTooltip]="'Admin'"
			matTooltipPosition="left"
			matTooltipClass="indicator__tooltip"
			[matTooltipDisabled]="!isCollapse"
		>
			<a
				class="menu__item-link"
				mat-button
				color="link"
				routerLink="admin"
				[ngClass]="{ 'link-collapse': isCollapse }"
			>
				<span class="icon icon-shield"></span>
				@if (!isCollapse) {
					<span class="label">Admin</span>
				}
			</a>
		</div>
		@if (!isCollapse) {
			<div class="menu-footer__help-links" data-test="menu-help-links">
				<a
					class="menu-footer__help-link"
					href="https://www.jepto.com/help"
					target="_blank"
					rel="noopener noreferrer"
					data-test="help-articles-link"
				>
					Help Articles
				</a>
				<a
					class="menu-footer__help-link"
					(click)="openLatestUpdates()"
					data-test="latest-updates-link"
				>
					Latest Updates
				</a>
			</div>
		}
	</div>
	<div
		id="side-bar-btn"
		class="side-bar-cont"
		[ngClass]="{ 'small-pos': isCollapse }"
	>
		@if (!isCollapse) {
			<jep-button
				type="icon-button"
				[icon]="'icon-chevron-left'"
				mat-mini-fab
				color="basic"
				(click)="left()"
				data-test="icon-chevron-left"
			>
			</jep-button>
		}
		@if (isCollapse) {
			<jep-button
				type="icon-button"
				[icon]="'icon-chevron-right'"
				mat-mini-fab
				color="basic"
				(click)="right()"
				data-test="icon-chevron-right"
			>
			</jep-button>
		}
	</div>
</div>
<!-- *ngIf="false" -->
<!-- <ul class="menu top" data-test="menu" id="parentMenu" style="border-top: 1px solid rgba(255, 255, 255, 0.12); padding-top: 10px;">

</ul> -->
<!-- <ul class="menu bot" id="parentMenu">
    <li class="menu__item" [ngClass]="activeAdminRouterLink ? 'menu__item--active' : ' '" data-test="dash-menu-item">
        <a class="menu__item-link" mat-button color="link" routerLink="settings">
            <span class="icon icon-shield"></span>
            <span class="label">Admin</span>
        </a>
    </li>
</ul> -->
